var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import React from 'react';
import styled from '@emotion/styled';
import { height, space, maxWidth, overflow } from 'styled-system';
import { IMAGE_RATIO } from '../../common/components/VisualNavigation';
import { Flex } from '../../common/components/Flex';
import { maxWidth as globalThemeMaxWidth } from '../../common/theme/theme';
import { RectShape } from '../../common/components/RectShape';
/**
 * There is no need to use the amount of slides loaded from GQL as this data is now loaded on the
 * client side. Therefore, I chose the fixed value of 8 because it is greater than the largest
 * number of slides visible at any breakpoint. So the placeholder will always be loaded as if
 * there were the amount needed to fill the entire slider.
 */
var FIXED_SLIDE_COUNT = 8;
/**
 * These quotients are the result of the division between: the whole component width and the
 * width of the slides generated by the Glide library in the CommonVisualNavigation component.
 * Values: ['small', 'medium', 'large', 'extra-large']
 */
var SLIDE_WIDTH_QUOTIENT = [2.46, 4.16, 4.7, 5.88];
var Container = styled(Flex)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n  ", ";\n"], ["\n  ", ";\n  ", ";\n"])), maxWidth, overflow);
Container.defaultProps = {
    width: 1,
    maxWidth: globalThemeMaxWidth,
    mx: 'auto',
    mb: ['sp_24', null, null, 'sp_32'],
    flexDirection: 'column',
    overflow: 'hidden',
};
var Title = styled(RectShape)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", ";\n  ", ";\n"], ["\n  ", ";\n  ", ";\n"])), height, space);
Title.defaultProps = __assign(__assign({}, RectShape.defaultProps), { width: ['85px', '95px', null, '105px'], height: ['18px', '20px', null, '22px'], mb: ['sp_12', 'sp_20', 'sp_24'] });
var SlidesContainer = styled(Flex)(templateObject_3 || (templateObject_3 = __makeTemplateObject([""], [""])));
SlidesContainer.defaultProps = {
    width: SLIDE_WIDTH_QUOTIENT.map(function (quotient) { return "calc((100% / " + quotient + ") * " + FIXED_SLIDE_COUNT + ")"; }),
};
var Slide = styled(Flex)(templateObject_4 || (templateObject_4 = __makeTemplateObject([""], [""])));
Slide.defaultProps = {
    width: SLIDE_WIDTH_QUOTIENT.map(function (quotient) { return "calc(100% / " + quotient + ")"; }),
    pr: ['sp_16', '18px', 'sp_20', 'sp_16'],
    alignItems: 'center',
    flexDirection: 'column',
};
var CategoryImage = styled(RectShape)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  ", ";\n  ", ";\n"], ["\n  ", ";\n  ", ";\n"])), height, space);
CategoryImage.defaultProps = __assign(__assign({}, RectShape.defaultProps), { pb: "calc(100% * " + IMAGE_RATIO + ")" });
var CategoryName = styled(RectShape)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  ", ";\n  ", ";\n"], ["\n  ", ";\n  ", ";\n"])), height, space);
CategoryName.defaultProps = __assign(__assign({}, RectShape.defaultProps), { height: ['20px', '24px', null, '26px'], mt: ['10px', '11px', '15px', 'sp_12'] });
var Placeholder = function (_a) {
    var _b = _a.showTitle, showTitle = _b === void 0 ? false : _b, showLoadingAnimation = _a.showLoadingAnimation;
    return (React.createElement(Container, { "data-testid": "custom-placeholder-container", className: showLoadingAnimation && 'show-loading-animation' },
        showTitle && React.createElement(Title, null),
        React.createElement(SlidesContainer, null, __spread(Array(FIXED_SLIDE_COUNT)).map(function (_, index) { return (React.createElement(Slide, { key: index },
            React.createElement(CategoryImage, null),
            React.createElement(CategoryName, null))); }))));
};
export default Placeholder;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
